import React from 'react';
import Table from '../common/Table';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import { showModal } from '../../actions/modal';

const operatorTypeToName = {
  MANUAL: `Свой склад`,
  FULFILLMENT: `Фулфилмент`,
};

const Wrapper = styled.div`
  padding-bottom: 0 !important;

  .badge {
    font-size: 12px;
    font-weight: 600;
  }

  .table-item {
    .title-wrapper {
      width: fit-content;
      position: relative;
    }

    .row-title {
      color: #72747b;
      font-weight: 500;
      font-size: 13px;
      margin: 0;
    }

    .row-comment {
      font-size: 11px;
      margin: 2px 0 0;
      color: #98a6ad;
    }

    i {
      display: none;
    }

    &:hover i {
      position: absolute;
      right: -20px;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      color: #98a6ad;
      cursor: pointer;
    }
  }
`;

const WarehousesBlock = () => {
  const { warehouses } = useSelector((state) => state.orders);

  const dispatch = useDispatch();

  const rows =
    warehouses?.map((item) => ({
      data: [
        {
          value: (
            <div className="title-wrapper">
              <h4 className="row-title">{item.title}</h4>
              {item.isDefault && <p className="row-comment">По умолчанию</p>}
              <i
                className="fe-edit-2"
                onClick={() =>
                  dispatch(showModal(`EditWarehouseSettings`, { title: `Редактирование`, item }))
                }
              />
            </div>
          ),
        },
        { value: operatorTypeToName[item.operatorType] },
        { value: <span className={`badge badge-success`}>Активен</span> },
      ],
    })) || [];

  return (
    <>
      <div className="border-bottom">
        <h4 className="header-title">Склады</h4>
      </div>
      <Wrapper>
        <Table data={{ cols: [`Наименование`, `Тип`, `Статус`], rows }} />
      </Wrapper>
    </>
  );
};

export default WarehousesBlock;
